import { axiosInstance } from 'services';
import { AxiosResponse } from 'axios';

import { getDeepDAOTokenFromStorage } from 'web3/storageHelper';

import { ISearchUserAddress, ISearchResponse, ISearchTopThree } from 'types/interfaces';

export const SearchApi = {
    search: ({ value, include }: { value: string; include: string }): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<ISearchResponse>(`search?include=${include}&value=${value}`, {
        //     headers: getDeepDAOTokenFromStorage() ? { Authorization: `Bearer ${getDeepDAOTokenFromStorage()}` } : null,
        // })
        Promise.resolve({
          data: {data: []},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
      }),
    searchUserAddress: (userId: string): Promise<AxiosResponse<any>> =>
        //axiosInstance.get<ISearchUserAddress>(`user/2/${userId}`)
        Promise.resolve({
          data: {data: []},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
      }),
    searchTopThree: (token?: string): Promise<AxiosResponse<any>> =>
        // axiosInstance.get<ISearchTopThree>('search/top-data', {
        //     headers:
        //         token || getDeepDAOTokenFromStorage()
        //             ? { Authorization: `Bearer ${token || getDeepDAOTokenFromStorage()}` }
        //             : null,
        // }),
        Promise.resolve({
          data: {data: []},
          status: 200,
          statusText: "OK",
          headers: {},
          config: {},
          request: {},
      })
};
